import CONSTANTS, { CONTENT_LIMIT } from "./constants";

const urlPrefix = "/v2/course/content";

const apiEndPoints = {
  [CONSTANTS.GET_COURSE_CONTENT]: {
    url: ({
      courseId,
      folderId = 0,
      limit = CONTENT_LIMIT,
      offset = 0,
      search = "",
      originalCourseId = -1,
    }) => {
      const url = new URL(window?.location?.href);
      const courseFromParam = url?.searchParams?.get("originalCourseId");
      if (courseFromParam) {
        originalCourseId = courseFromParam;
      }
      return `${urlPrefix}/get?courseId=${courseId}&folderId=${folderId}&limit=${limit}&offset=${offset}&search=${search}&originalCourseId=${originalCourseId}`;
    },
    method: "GET",
  },
  [CONSTANTS.GET_TRIAL_COURSE_CONTENT]: {
    url: ({
      courseId,
      folderId = 0,
      limit = CONTENT_LIMIT,
      offset = 0,
      search = "",
      originalCourseId = -1,
    }) => {
      const url = new URL(window?.location?.href);
      const courseFromParam = url?.searchParams?.get("originalCourseId");
      if (courseFromParam) {
        originalCourseId = courseFromParam;
      }
      return `${urlPrefix}/get?courseId=${courseId}&folderId=${folderId}&limit=${limit}&offset=${offset}&search=${search}&originalCourseId=${originalCourseId}&isTrial=1`;
    },
    method: "GET",
  },
  [CONSTANTS.GET_FREE_COURSE_CONTENT]: {
    url: ({ courseId, limit = CONTENT_LIMIT, offset = 0 }) => {
      return `${urlPrefix}/get?courseId=${courseId}&freeContent=1&limit=${limit}&offset=${offset}`;
    },
    method: "GET",
  },
  [CONSTANTS.GET_COURSE_CONTENT_TEST_STATS]: {
    url: ({ courseId, testId, contentId }) => {
      return `${urlPrefix}/testStats/${courseId}/${testId}/${contentId}`;
    },
    method: "GET",
  },
  [CONSTANTS.GET_TEST_LEADERBOARD_STATS]: {
    url: ({ contentId, courseId, limit = 20, offset = 0 }) => {
      return `${urlPrefix}/leaderboard/${contentId}?offset=${offset}&limit=${limit}&courseId=${courseId}`;
    },
    method: "GET",
  },
  [CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE_SERVICE]: {
      url: ({  }) => {
        return `/v2/otp/generate`;
      },
      method: "POST",
    },
  
    [CONSTANTS.IDFY_PREPURCHAGE_OTP_RE_GENERATE_SERVICE]:{
       url: ({  }) => {
        return `/v2/otp/retry`;
      },
      method: "POST",
    },
  
    [CONSTANTS.IDFY_PREPURCHAGE_OTP_VERIFY_SERVICE]:{
       url: ({  }) => {
        return `/v3/course/verify/otp`;
      },
      method: "POST",
    },
  
    [CONSTANTS.IDFY_POSTPURCHAGE_IDENTITY_VERIFY_SERVICE]:{
       url: ({  }) => {
        return `/v3/course/student/kyc/init`;
      },
      method: "POST",
    },
  [CONSTANTS.GET_SUBJECTIVE_TEST_DOWNLOAD_URL]: {
    url: ({ studentTestId, testId, type }) => {
      return `/v2/course/content/subjectiveTest/downloadUrl?studentTestId=${studentTestId}&testId=${testId}&type=${type}`;
    },
    method: "GET",
  },
  [CONSTANTS.GET_CONTENT_ATTACHMENTS]: {
    url: ({ sourceContentId }) => {
      return `${urlPrefix}/video/attachments?sourceContentId=${sourceContentId}`;
    },
    method: "GET",
  },
};

export default apiEndPoints;
